import { LineChartOutlined } from "@ant-design/icons";
import { RedirectPage } from "components/UI/RedirectPage/RedirectPage.tsx";
import { Route as AdvertiserReportPage } from "routes/_authenticated/$tenantSlug/_layout/report/_layout/advertiser";
import { Route as AffiliateReportPage } from "routes/_authenticated/$tenantSlug/_layout/report/_layout/affiliate";
import { Route as EventReportPage } from "routes/_authenticated/$tenantSlug/_layout/report/_layout/event";
import { Route as OfferReportPage } from "routes/_authenticated/$tenantSlug/_layout/report/_layout/offer";
import { Route as PerformanceReportPage } from "routes/_authenticated/$tenantSlug/_layout/report/_layout/performance";
import { Route as PingReportPage } from "routes/_authenticated/$tenantSlug/_layout/report/_layout/ping";
import { Route as PingTreeReportPage } from "routes/_authenticated/$tenantSlug/_layout/report/_layout/pingtree";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/report/")({
    component: ReportsPage,
    staticData: {
        permissions: [
            PermissionEnum.ReportPerformance,
            PermissionEnum.ReportAffiliate,
            PermissionEnum.ReportAdvertiser,
            PermissionEnum.ReportOffer,
            PermissionEnum.ReportCascade,
            PermissionEnum.ReportEvent,
            PermissionEnum.ReportConversion,
            PermissionEnum.ReportEvent,
        ],
        showInSideMenu: true,
        label: "pages.report.title",
        icon: <LineChartOutlined />,
        sort: 2,
        redirects: [
            AdvertiserReportPage,
            AffiliateReportPage,
            EventReportPage,
            OfferReportPage,
            PerformanceReportPage,
            PingReportPage,
            PingTreeReportPage,
        ],
        defaultRedirect: PerformanceReportPage,
    },
});

function ReportsPage() {
    return <RedirectPage />;
}
